import ParameterFieldBase, { IParameterFieldBaseOptions } from './ParameterFieldBase';
import EditComponent from '../tsx/ThemesListField';
import * as appTheme from './appTheme';

import { IGlob } from '../../../pdc-platform/src/ts/Glob';

export default class ThemesListField extends ParameterFieldBase<IParameterFieldBaseOptions> {
    public static EditComponent = EditComponent;

    constructor(glob: IGlob, title: string, validators?: any, defaultVal: any = {}, options?) {
        super(glob, title, [appTheme.themesValidator], validators, defaultVal, options);
    }
}
